/**
 * Phase 45 Plan 45-07 (D-03) — claimable feed (unassigned tasks scoped to
 * caller's projects).
 *
 * Wraps GET /api/tasks/unassigned (Plan 45-03).
 *
 * Petra UAT 2026-05-19 — query key includes the effective user id
 * (impersonated when active, otherwise own) so the cache doesn't bleed
 * the admin's claimable backlog across into an impersonated persona's view.
 * Same fix as useMyTasks per persona-scoped cache invariant.
 */
import { useQuery } from '@tanstack/react-query';
import { fetchUnassignedTasks, type UnassignedTaskDto } from '../services/api/tasks';
import { useAuthOptional } from '../services/authContext';

export const UNASSIGNED_TASKS_BASE_KEY = ['tasks', 'unassigned'] as const;

export function useUnassignedTasks() {
  const auth = useAuthOptional();
  const effectiveUserId = auth?.impersonatedUser?.id ?? auth?.user?.id ?? null;
  return useQuery<UnassignedTaskDto[]>({
    queryKey: [...UNASSIGNED_TASKS_BASE_KEY, effectiveUserId],
    queryFn: fetchUnassignedTasks,
    staleTime: 30_000,
    enabled: effectiveUserId != null,
  });
}

export type { UnassignedTaskDto };
